import React, { useEffect } from 'react';
import { initializeLiff, initializeFbSDK, facebookSafeHashtag } from '../../utill.func';
import { CHALLENGE, CHALLENGE_UNLOCKED } from '../challengeConstants';
import './ChallengeShare.scss'
import CustomSweetAlert from '../customSweetAlert/CustomSweetAlert';

const ChallengeShare = ({ imgPath, imgPathFb, message }) => {

  useEffect(() => {
    initializeFbSDK();
  }, []);

  const shareOnFacebook = () => {
    const hashtag = facebookSafeHashtag(message);
    console.log({ method: 'share', href: imgPathFb, hashtag: `${hashtag}` });
    window.FB.ui({ method: 'share', href: imgPathFb, hashtag: `${hashtag}` },
      (response) => {
        if (typeof response != 'undefined') {
          // alert(CHALLENGE_UNLOCKED.SHARE_SUCCESS_MESSAGE);
        }
        else {
          CustomSweetAlert({
            title: "",
            text: CHALLENGE_UNLOCKED.SHARE_FAILURE_MESSAGE,
            confirmButtonText: "ตกลง",
          })
        }
      });
  }

  const shareOnInstagram = () => {
    //no support for instagram
    alert(CHALLENGE_UNLOCKED.INSTA_MESSAGE);
  };

  const shareOnLine = async () => {
    try {
      const liff = await initializeLiff();
      if (liff) {
        await liff.shareTargetPicker(
          [{ type: "image", originalContentUrl: imgPath, previewImageUrl: imgPath },
          { type: "text", text: message }],
          { isMultiple: true }
        );
      }
    } catch (error) {
      CustomSweetAlert({
        title: "",
        text: CHALLENGE_UNLOCKED.SHARE_FAILURE_MESSAGE,
        confirmButtonText: "ตกลง",
      })
    }
  };


  return (
    <div className={'challenge-share-container'}>
      <div className='map-goal-share-section'>
        <span className='share-title'>{CHALLENGE.mapDetail.share}</span>
        <img onClick={shareOnFacebook} src={'/images/challenge/icons/fb_icon.svg'} />
        {/* hiding below instagram icon until approach is finalized */}
        {/* <img onClick={shareOnInstagram} src={'/images/challenge/icons/insta_icon.svg'} /> */}
        <img onClick={shareOnLine} src={'/images/challenge/icons/line_icon.svg'} />
      </div>
    </div>
  )
}

export default ChallengeShare